import { render, staticRenderFns } from "./scrolldown.vue?vue&type=template&id=620545de&scoped=true"
import script from "./scrolldown.vue?vue&type=script&lang=js"
export * from "./scrolldown.vue?vue&type=script&lang=js"
import style0 from "./scrolldown.vue?vue&type=style&index=0&id=620545de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620545de",
  null
  
)

export default component.exports